import React from 'react';

const CalcHeader = ({}) => {
    return (
        <header className='header-calc'>
            <div className='form__inputs header-calc__content'>
                <img src='img/logo.svg' className='pooling-express-logo' alt='logo'/>
            </div>
        </header>
    );
};

export default CalcHeader;


// WEBPACK FOOTER //
// ./App/containers/header/calcHeader.jsx